import { Injectable } from '@angular/core';

import { RestService } from "../../../core/services/rest.service";
import { Destino } from "./destino.model";
import { apiName } from "./data.service";

@Injectable()
export class DestinoApiService {

    constructor(
        private _restService: RestService
    ) { }

    onPost(object: Destino, done: any) {
        this._restService.onPost(apiName, object, done);
    }

    onPut(object: Destino, done: any) {
        this._restService.onPut(apiName, object, done);
    }

    onDelete(objectId: number, done: any) {
        this._restService.onDelete(apiName, objectId, done);
    }

    onGetAll(done: any) {
        let filter: any = {"order":"destino"};
        this._restService.onGetPost(apiName, filter, done);
    }

    onGetAllActive(done: any) {
        let filter: any = {"where":{"ativo":true},"order":"destino"};
        this._restService.onGetPost(apiName, filter, done);
    }

    onGetById(objectId: number, done: any) {
        this._restService.onGetPostId(apiName, objectId, {}, done);
    }

    onGetApiUrl() {
        return apiName;
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/destinos/shared/destino-api.service.ts
 **/